import { render, staticRenderFns } from "./scents.vue?vue&type=template&id=ea1e75e0&"
import script from "./scents.vue?vue&type=script&lang=js&"
export * from "./scents.vue?vue&type=script&lang=js&"
import style0 from "./scents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports